import { FC } from 'react';
import { Box } from '@mui/material';
import PartyLedgerJournal from '../../components/Reports/PartyLedgerJournal';

/**
 * Party Ledger Journal Report Page
 * Displays party ledger transactions from journal entries
 */
const PartyLedgerJournalPage: FC = () => {
    return (
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <PartyLedgerJournal />
        </Box>
    );
};

export default PartyLedgerJournalPage;
